import React from 'react';
import { Button } from 'antd';

const CustomButton = ({
  children,
  type = 'default',
  variant = 'default',
  color = 'primary',
  size = 'middle',
  loading = false,
  disabled = false,
  onClick,
  icon,
  iconPosition = 'start',
  className = '',
  style = {},
  ...props
}) => {
  // Map variant to Ant Design button types
  const getButtonType = () => {
    switch (variant) {
      case 'contained':
        return 'primary';
      case 'outlined':
        return 'default';
      case 'text':
        return 'text';
      case 'link':
        return 'link';
      default:
        return type;
    }
  };

  // Get button properties
  const getButtonProps = () => {
    const buttonProps = {
      type: getButtonType(),
      size,
      loading,
      disabled,
      onClick,
      className,
      style,
      ...props
    };

    // Add icon and iconPosition if icon is provided
    if (icon) {
      buttonProps.icon = icon;
      buttonProps.iconPosition = iconPosition; // 'start' or 'end'
    }

    // Handle color variants
    if (color === 'error' || type === 'error') {
      buttonProps.danger = true;
    }

    // Handle color variants for primary buttons
    if (color && color !== 'primary' && color !== 'error') {
      buttonProps.color = color; // Ant Design supports 'default', 'primary', 'danger'
    }

    return buttonProps;
  };

  return (
    <Button {...getButtonProps()} style={{ display: 'flex', alignItems: 'center', ...style }}>
      {children}
    </Button>
  );
};

export default CustomButton;